export interface SharedValues {
  name: SharedSource;
  data: any;
}

export enum SharedSource {
  changeCustomer,
  partnerIdReady,
  roleChanged
}
